<mat-toolbar>
  <button
    (click)="drawer.toggle()"
    mat-icon-button
    aria-label="Mostrar / Ocultar menu principal de la aplicación">
    <mat-icon>menu</mat-icon>
  </button>
  <div class="logo">
    <img src="assets/slide-login/4piot-logotipo.webp" alt="Logo 4Piot" />
  </div>
</mat-toolbar>
